var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEasyIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.375C12.4467 6.375 11.1875 7.6342 11.1875 9.1875C11.1875 10.7408 12.4467 12 14 12C15.5533 12 16.8125 10.7408 16.8125 9.1875C16.8125 7.6342 15.5533 6.375 14 6.375Z",
    fill: "#32AE4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 3.09375C0.875 1.79933 1.92433 0.75 3.21875 0.75H24.7812C26.0757 0.75 27.125 1.79933 27.125 3.09375V15.2813C27.125 16.5757 26.0757 17.625 24.7812 17.625H3.21875C1.92433 17.625 0.875 16.5757 0.875 15.2813V3.09375ZM9.3125 9.1875C9.3125 6.59867 11.4112 4.5 14 4.5C16.5888 4.5 18.6875 6.59867 18.6875 9.1875C18.6875 11.7763 16.5888 13.875 14 13.875C11.4112 13.875 9.3125 11.7763 9.3125 9.1875ZM22.4375 8.25C21.9197 8.25 21.5 8.66973 21.5 9.1875V9.19688C21.5 9.71464 21.9197 10.1344 22.4375 10.1344H22.4469C22.9646 10.1344 23.3844 9.71464 23.3844 9.19688V9.1875C23.3844 8.66973 22.9646 8.25 22.4469 8.25H22.4375ZM4.625 9.1875C4.625 8.66973 5.04473 8.25 5.5625 8.25H5.57188C6.08964 8.25 6.50938 8.66973 6.50938 9.1875V9.19688C6.50938 9.71464 6.08964 10.1344 5.57188 10.1344H5.5625C5.04473 10.1344 4.625 9.71464 4.625 9.19688V9.1875Z",
    fill: "#32AE4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 19.5C1.29473 19.5 0.875 19.9197 0.875 20.4375C0.875 20.9553 1.29473 21.375 1.8125 21.375C8.56256 21.375 15.1003 22.2778 21.3122 23.9686C22.8004 24.3737 24.3125 23.271 24.3125 21.6939V20.4375C24.3125 19.9197 23.8928 19.5 23.375 19.5H1.8125Z",
    fill: "#32AE4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyIntegrationIcon);
export default __webpack_public_path__ + "static/media/easy-integration-icon.ee91f63809e9c27472a678a1de0da0c3.svg";
export { ForwardRef as ReactComponent };